import $ from 'jquery'
import _ from 'lodash'
import moment from 'moment-timezone'
import ss from './data/sessao'
import cli from './data/cliente'
import config from './data/config'

import globalMixins from './mixins/global.js'
import modulos from './mixins/modulos.js'
import vmask from './mixins/vmask.js'
import cliente from './mixins/cliente.js'
import date from './mixins/date.js'
import label from './mixins/label.js'
import tempo from './mixins/tempo.js'
import croap from './mixins/croap.js'
import aisweb from './mixins/aisweb.js'
import http from './mixins/http.js'
import calculo from './mixins/calculo.js'
import botoes_mapas from './mixins/mapa.js'
import providerEstado from './providers/estado.js'
import providerRotaer from './providers/rotaer.js'
import providerOrgaoApoiado from './providers/orgao-apoiado.js'
import providerOrgao from './providers/orgao.js'
import providerClassificacao from './providers/classificacao.js'
import providerAeronave from './providers/aeronave.js'
import providerParametro from './providers/parametro.js'
import providerUnidade from './providers/unidade-conservacao.js'
import providerSetor from './providers/setor.js'
import providerBase from './providers/base-origem.js'
import providerSub from './providers/subclassificacao.js'
import providerContextoOperativo from './providers/contexto-operativo.js'
import providerBaseOperacional from './providers/base-operacional.js'
import providerTipoDeMissao from './providers/tipo-de-missao.js'
import providerDescricaoDaMissao from './providers/descricao-da-missao.js'


import Vue from 'vue'
global.bus = new Vue

Vue.mixin(globalMixins);
Vue.mixin(modulos);
Vue.mixin(vmask);
Vue.mixin(cliente);
Vue.mixin(date);
Vue.mixin(label);
Vue.mixin(aisweb);
Vue.mixin(tempo);
Vue.mixin(croap);
Vue.mixin(http);
Vue.mixin(calculo);
Vue.mixin(botoes_mapas);
Vue.mixin(providerEstado);
Vue.mixin(providerRotaer);
Vue.mixin(providerOrgaoApoiado);
Vue.mixin(providerOrgao);
Vue.mixin(providerClassificacao);
Vue.mixin(providerAeronave);
Vue.mixin(providerParametro);
Vue.mixin(providerUnidade);
Vue.mixin(providerBase);
Vue.mixin(providerSub);
Vue.mixin(providerContextoOperativo);
Vue.mixin(providerBaseOperacional);
Vue.mixin(providerTipoDeMissao);
Vue.mixin(providerDescricaoDaMissao);
Vue.mixin(providerSetor);

window.$ = $
window.jQuery = $
window._ = _
window.moment = moment
window.$sessao = ss
window.$cliente = cli
window.$config = config

require('./prototypes/number.js')
require('./prototypes/string.js')
import 'font-awesome/css/font-awesome.css' // << import CSS
require('./data/traducao.js')
require('bootstrap')
require('jquery-slimscroll')

require('./assets/css/boostrap-datatimepicker.css')
require('./assets/js/boostrap-datetimepicker.js')
require('./assets/js/MeasureTool.js')

require('./assets/css/followair-icones.css') // inputa os icones
require('./assets/css/tooltip.css') // inputa os icones
require('./assets/css/timeline.css') // inputa os icones
require('./assets/css/flightindicators.css') // inputa os icones
require('./assets/css/animate.css') // inputa os icones
require('./assets/css/utils.css') // inputa os utils
require('./assets/css/global.css') // inputa os estilos globais
require('./assets/css/jivochat.css')

require('./assets/js/jquery.flightindicators.js')
require('./assets/js/jivochat.js')


require('./assets/less/all.less')

import filters from './filters'

import Router from 'vue-router'
Vue.use(Router)

import vSelect from './modules/components/vue-select/index'
Vue.component('v-select', vSelect)

import vueSelect from 'vue-select'
Vue.component('vue-select', vueSelect)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
	defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

// v-money <money v-model="form.carga_horaria" v-bind="_vmoney" class="form-control input-sm"></money>
import money from 'v-money' // https://github.com/vuejs-tips/v-money
Vue.use(money, {precision: 4})

import VueMask from 'di-vue-mask' // https://www.npmjs.com/package/di-vue-mask
Vue.use(VueMask);

import Notifications from 'vue-notification' // https://github.com/euvl/vue-notification/
Vue.use(Notifications)

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
Vue.use(DatePicker)

import router from './routes/index.js'
import 'vue-select/dist/vue-select.css';

import VueHtml5Editor from 'vue-html5-editor'
Vue.use(VueHtml5Editor, {
	showModuleName: true,
	image: {
			sizeLimit: 512 * 1024,
			compress: true,
			width: 500,
			height: 500,
			quality: 80
	}
});


Vue.directive('focus', {
	inserted: function(el){
		el.focus()
	}
})

new Vue({
	el: '#app',
	router,
	render: (h) => h('router-view'),

	data () {
		return {
			type: '',
			text: '',
		}
	},
	mounted (){

		if($cliente.getVersao('versao') === 'P'){
			$(document).prop('title', 'Followair Police');
		}

		if($cliente.getVersao('versao') === 'F'){
			$(document).prop('title', 'Followair Fire');
		}

		if($cliente.getVersao('versao') === 'G'){
			$(document).prop('title', 'Followair Green');
		}

		if($cliente.getVersao('versao') === 'C'){
			$(document).prop('title', 'Followair Corporate');
		}

		if($cliente.getVersao('versao') === 'TX'){
			$(document).prop('title', 'Followair TX');
		}

		if($cliente.getVersao('versao') === 'M'){
			$(document).prop('title', 'Followair Med');
		}

		if($cliente.getVersao('versao') === 'GV'){
			$(document).prop('title', 'Aviação da Casa Militar');
		}

		// seta a linguagem
		if(!localStorage.getItem('__POLICE_SESSION_LG_')) {
			this._setaLg('pt-br')
		}

		bus.$on('exibir-notificacao', (config) => {

			if(config.type === 'warning'){
				this.type = 'warn'
			}

			if(config.type === 'success'){
				this.type = 'success'
			}

			if(config.type === 'info' || config.type === 'notify'){
				this.type = config.type
			}

			if(config.type === 'danger'){
				this.type = 'error'
			}

			this.text = config.text
			this.exibeNotificacao(config.duration)
		});
	},

	methods: {

		exibeNotificacao (duration = 10000){

			this.$notify({
				group: 'notify',
				type: this.type,
				text: this.getTemplate(),
				class: 'no-print',
				duration: duration,
				speed: 1000
			});
		},

		getTemplate (){
			let template = '<div class="row" style="padding:20px 10px"><table><tr><td class="text-center" style="width: 15%; padding: 0px 20px 0px 20px">';

			if(this.type === 'warn'){
				template += '<i class="fa fa-2x fa-exclamation-triangle" aria-hidden="true"></i>'
			}

			if(this.type === 'info'){
				template += '<i class="fa fa-info-circle fa-2x" aria-hidden="true"></i>'
			}

			if(this.type === 'success'){
				template += '<i class="fa fa-check-circle fa-2x"></i>'
			}

			if(this.type === 'error'){
				template += '<i class="fa fa-times fa-2x" aria-hidden="true"></i>'
			}

			if(this.type === 'notify'){
				template += '<i class="fa fa-bell fa-2x" aria-hidden="true"></i>'
			}

			template += `</td><td><p style="margin:0px; font-size:18px; padding: 0px 20px 0px 0px">${this.text}</p></td></tr></table></div>`;

			return template
		}
	}
})

Vue.prototype.$filters = Vue.options.filters



